import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService, CongresosService, CategoriaTrabajoService, TrabajosService, MailService, TranslationService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';
import { CategoriaTrabajo } from '../../models/categoriaTrabajo.model';
import { Autor } from '../../models/autor.model';
import { CKEditorComponent } from 'ng2-ckeditor';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';

declare var $;

// declare var CKEDITOR: any;

// CKEDITOR.plugins.addExternal(
//   'symbol',
//   '/symbol',
//   'plugin.js');

@Component({
  selector: 'app-trabajos',
  templateUrl: './trabajos.component.html',
  styles: []
})
export class TrabajosComponent implements OnInit {

  congreso: Congreso;
  categoriasTrabajo: CategoriaTrabajo[] = [];
  opcionesCategorias: CategoriaTrabajo[] = [];
  autores: Autor[] = [];
  lugaresTrabajo: any[] = [];
  lugaresTrabajo2: any[] = [];
  hideModal: string = 'hide-modal';
  hideModal2: string = 'hide-modal';
  hideModalCategoriaTrabajo: string = 'hide-modal';
  autorNombre: string;
  autorApellido: string;
  addLugar: boolean = false;
  lugar: string;
  countLugares: number = 1;
  lugaresTrabajoAutor: any[] = [];
  editarAutor: number;
  titulo: string = '';
  tituloValido: any = 'pristine';
  categoriaTrabajo: any;
  categoriaTrabajoObj: any;
  categSelected: any;
  categoriaTrabajoValido: any = 'pristine';
  errorNombreAutor: boolean = false;
  errorApellidoAutor: boolean = false;
  errorLugarTrabajoAutor: boolean = false;
  textoTrabajo: any;
  textoTrabajoLength: number;
  forma: FormGroup;
  emailValido: any = 'pristine';

  envioHabilitado: boolean = false;

  arbolDeCategorias: any[];
  arbolDeCategorias2: any[];

  loading: boolean = true;

  @ViewChild(CKEditorComponent) ckeditor: CKEditorComponent;

  constructor( public _userService: UserService,
    public _congresosService: CongresosService,
    public _categoriaTrabajoService: CategoriaTrabajoService,
    public _trabajosService: TrabajosService,
    public router: Router,
    public _mailService: MailService,
    public _translationService: TranslationService ) {
      this._userService.actualizarUsuario();
      this.forma = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
        }
      );
      if (this._userService.user.estadoTrabajo !== 'pendiente') {
        this.router.navigate(['/dashboard']);
      }
    }

  ngOnInit() {
    this.cargarCongreso();
    this.cargarCategorias();
    $(document).ready(function() {
      $('body').tooltip({ selector: '[data-toggle=tooltip]' });
    });
  }

  ngAfterViewChecked() {
    if (this.envioHabilitado) {
      let editor = this.ckeditor.instance;
    editor.config.height = '300';

    editor.config.toolbarGroups = [
      { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
      { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
      { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
      { name: 'forms', groups: [ 'forms' ] },
      '/',
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
      { name: 'links', groups: [ 'links' ] },
      { name: 'insert', groups: [ 'insert' ] },
      '/',
      { name: 'styles', groups: [ 'styles' ] },
      { name: 'colors', groups: [ 'colors' ] },
      { name: 'tools', groups: [ 'tools' ] },
      { name: 'others', groups: [ 'others' ] },
      { name: 'about', groups: [ 'about' ] }
    ];
    editor.config.removeButtons = 'Source,Save,Templates,Cut,Copy,NewPage,Preview,Print,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Bold,Strike,CopyFormatting,NumberedList,BulletedList,Outdent,Indent,Blockquote,CreateDiv,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,BidiLtr,BidiRtl,Language,Link,Unlink,Anchor,Image,Flash,Table,HorizontalRule,Smiley,PageBreak,Iframe,Styles,Format,Font,FontSize,TextColor,BGColor,Maximize,ShowBlocks,About,SpecialChar';
    }
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today < this.congreso.fechaFinTrabajos && today > this.congreso.fechaInicioTrabajos) {
          this.envioHabilitado = true;
          // Agrego Autor default y lugar trabajo
          let objetoLugar: any = {
            id: 1,
            nombre: this._userService.user.lugarTrabajo
          };
          this.lugaresTrabajo.push(objetoLugar);
          let objetoAutor: Autor = {};
          objetoAutor.nombres = this._userService.user.name;
          objetoAutor.apellido = this._userService.user.apellido;
          objetoAutor.lugaresTrabajo = [];
          objetoAutor.lugaresTrabajo.push(this.lugaresTrabajo[0].id);
          this.autores.push(objetoAutor);
        } else {
          this.envioHabilitado = false;
        }
        this.loading = false;
      }
    });
  }

  cargarCategorias() {
    // Lleno las opciones de Categorias Trabajo
    this.categoriasTrabajo = [];
    this._categoriaTrabajoService.getAllCategoriasTrabajo().subscribe((resp: any) => {
      this.categoriasTrabajo = [];
      for (let categoriaTrabajo of resp.categoriasTrabajo) {
        // Nivel 0
        if (!categoriaTrabajo.parent) {
          categoriaTrabajo.nivel = 0;
          this.categoriasTrabajo.push(categoriaTrabajo);
          // Nivel 1
          if (categoriaTrabajo.childrens) {
            for (let categHija of categoriaTrabajo.childrens) {
              categHija.nivel = 1;
              this.categoriasTrabajo.push(categHija);
              // Nivel 2
              if (categHija.childrens) {
                for (let categHija2 of categHija.childrens) {
                  categHija2.nivel = 2;
                  this.categoriasTrabajo.push(categHija2);
                  // Nivel 3
                  if (categHija2.childrens) {
                    for (let categHija3 of categHija2.childrens) {
                      categHija3.nivel = 3;
                      this.categoriasTrabajo.push(categHija3);
                      // Nivel 4
                      if (categHija3.childrens) {
                        for (let categHija4 of categHija3.childrens) {
                          categHija4.nivel = 4;
                          this.categoriasTrabajo.push(categHija4);
                          if (categHija4.childrens) {
                            for (let categHija5 of categHija4.childrens) {
                              categHija5.nivel = 5;
                              this.categoriasTrabajo.push(categHija5);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });
  }

  showAutorModal() {
    this.hideModal = '';
  }

  showRevisarTrabajoModal() {
    this.hideModal2 = '';
  }

  showModalCategoriaTrabajo() {
    this.hideModalCategoriaTrabajo = '';
    this.cargarOpcionesCategorias();
  }

  hideModalMethod() {
    this.hideModal = 'hide-modal';
    this.reiniciarEditAutor();
  }

  hideModalMethod2() {
    this.hideModal2 = 'hide-modal';
  }

  hideModalCategTrabajoMethod() {
    this.hideModalCategoriaTrabajo = 'hide-modal';
    this.reiniciarSeleccionCategoria();
  }

  cargarOpcionesCategorias(categoria_id ?: string) {
    this.reiniciarSeleccionCategoria();
    if (!categoria_id) {
      this.opcionesCategorias = [];
      for (let categ of this.categoriasTrabajo) {
        if (categ.nivel === 0) {
          this.opcionesCategorias.push(categ);
        }
      }
    } else {
      for (let categ of this.categoriasTrabajo) {
        if (categ._id === categoria_id) {
          this.categSelected = categ;
        }
      }
      if (this.categSelected.childrens.length > 0) {
        this.opcionesCategorias = [];
        for (let categHijo of this.categSelected.childrens) {
          this.opcionesCategorias.push(categHijo);
        }
      } else {
        this.categSelected.activo = true;
      }
    }
  }

  volverCategoria() {
    if (!this.categSelected.parent) {
      this.reiniciarSeleccionCategoria();
      this.cargarOpcionesCategorias();
    } else {
      this.seleccionarCategoria(this.categSelected.parent);
    }
  }

  reiniciarSeleccionCategoria() {
    this.categSelected = undefined;
    this.arbolDeCategorias2 = undefined;
    for (let categoria of this.categoriasTrabajo) {
      let categ: any = categoria;
      categ.activo = false;
    }
  }

  seleccionarCategoria(categoria_id: string) {
    this.cargarOpcionesCategorias(categoria_id);
    let arbol: any = this.getArbolCategorias(categoria_id);
              this._categoriaTrabajoService.getArbolCategorias(arbol).subscribe((resp: any) => {
                this.arbolDeCategorias2 = resp.categoriasTrabajo.reverse();
                this.categoriaTrabajoObj = this.arbolDeCategorias2[0];
              });
  }

  confirmarCategoriaTrabajo() {
    this.categoriaTrabajo = JSON.parse(JSON.stringify(this.categSelected._id));
    this.hideModalCategTrabajoMethod();
    let arbol: any = this.getArbolCategorias(this.categoriaTrabajo);
              this._categoriaTrabajoService.getArbolCategorias(arbol).subscribe((resp: any) => {
                this.arbolDeCategorias = resp.categoriasTrabajo.reverse();
              });
  }

  cambiarCategoria() {
    this.categoriaTrabajo = undefined;
    this.arbolDeCategorias = undefined;
    this.showModalCategoriaTrabajo();
  }

  agregarLugar() {
    this.addLugar = true;
  }

  nuevoLugar() {
    if (this.lugar) {
      this.countLugares = this.countLugares + 1;
      let objetoLugar: any = {
        id: this.countLugares,
        nombre: this.lugar
      };
      this.lugaresTrabajo.push(objetoLugar);
      this.lugaresTrabajoAutor.push(objetoLugar.id);
      this.addLugar = false;
      this.lugar = undefined;
    }
  }

  guardarAutor() {
    this.errorNombreAutor = false;
    this.errorApellidoAutor = false;
    this.errorLugarTrabajoAutor = false;
    if (!this.autorNombre || this.autorNombre === '') {
      this.errorNombreAutor = true;
      return;
    } else {
      if (!this.autorApellido || this.autorApellido === '') {
        this.errorApellidoAutor = true;
        return;
      } else {
        if (this.lugaresTrabajoAutor.length === 0) {
          this.errorLugarTrabajoAutor = true;
          return;
        } else {
          if (this.editarAutor !== undefined) {
            this.autores[this.editarAutor].nombres = this.capitalize(this.autorNombre);
            this.autores[this.editarAutor].apellido = this.capitalize(this.autorApellido);
            this.autores[this.editarAutor].lugaresTrabajo = this.lugaresTrabajoAutor;
            this.reiniciarEditAutor();
          this.hideModalMethod();
          let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Autor Editado';
            mensajeSwal = 'Autor editado satisfactoriamente';
          } else {
            tituloSwal = 'Author Edited';
            mensajeSwal = 'Author successfully edited';
          }
          swal(tituloSwal, mensajeSwal, 'success');
          } else {
            let objetoAutor: Autor = {};
          objetoAutor.nombres = this.capitalize(this.autorNombre);
          objetoAutor.apellido = this.capitalize(this.autorApellido);
          objetoAutor.lugaresTrabajo = this.lugaresTrabajoAutor;
          this.autores.push(objetoAutor);
          this.reiniciarEditAutor();
          this.hideModalMethod();
          let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Autor Creado';
            mensajeSwal = 'Autor creado satisfactoriamente';
          } else {
            tituloSwal = 'Author Created';
            mensajeSwal = 'Author created successfully';
          }
          swal(tituloSwal, mensajeSwal, 'success');
          }
        }
      }
    }

  }

  estaEnAutor(lugar_id: number) {
    if (this.lugaresTrabajoAutor.indexOf(lugar_id) > -1) {
      return true;
    } else {
      return false;
    }
  }

  selectLugarTrabajo(lugar_id: number) {
    let index: number = this.lugaresTrabajoAutor.indexOf(lugar_id);
    if (index < 0) {
      this.lugaresTrabajoAutor.push(lugar_id);
    } else {
      this.lugaresTrabajoAutor.splice(index, 1);
    }
  }

  nombreLugar(lugar_id: number) {
    for (let lugar of this.lugaresTrabajo) {
      if (lugar.id === lugar_id) {
        return lugar.nombre;
      }
    }
  }

  editAutor(index: number) {
    this.editarAutor = index;
    this.autorNombre = this.autores[index].nombres;
    this.autorApellido = this.autores[index].apellido;
    this.lugaresTrabajoAutor = this.autores[index].lugaresTrabajo.slice();
    this.showAutorModal();
    $('#editarTooltip_' + index).tooltip('hide');
  }

  reiniciarEditAutor() {
    this.editarAutor = undefined;
    this.autorNombre = undefined;
    this.autorApellido = undefined;
    this.lugaresTrabajoAutor = [];
  }

  borrarAutor(index: number) {
    let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          let buttons: string[];
          let mensajeExitoSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Borrar Autor';
            mensajeSwal = '¿Desea borrar autor?';
            buttons = ['No', 'Si'];
            mensajeExitoSwal = 'Autor borrado satisfactoriamente';
          } else {
            tituloSwal = 'Delete Author';
            mensajeSwal = 'Do you want to delete the author?';
            buttons = ['No', 'Yes'];
            mensajeExitoSwal = 'Author successfully deleted';
          }

    swal({
      title: tituloSwal,
      text: mensajeSwal,
      icon: 'error',
      buttons: [buttons[0], buttons[1]]
    })
    .then((willDelete) => {
      if (willDelete) {
        this.autores.splice(index, 1);
        swal(tituloSwal, mensajeExitoSwal, 'success');
      }
    });
    $('#borrarTooltip_' + index).tooltip('hide');
  }

  subirAutor( index: number ) {
    this.array_move(this.autores, index, (index - 1));
    $('#subirTooltip_' + index).tooltip('hide');
    let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Autor Movido';
            mensajeSwal = 'El autor ah sido movido correctamente.';
          } else {
            tituloSwal = 'Author Order Change';
            mensajeSwal = 'The author has been moved correctly.';
          }

    swal(tituloSwal, mensajeSwal, 'success');
  }

  bajarAutor( index: number ) {
    this.array_move(this.autores, index, (index + 1));
    $('#bajarTooltip_' + index).tooltip('hide');
    let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Autor Movido';
            mensajeSwal = 'El autor ah sido movido correctamente.';
          } else {
            tituloSwal = 'Author Order Change';
            mensajeSwal = 'The author has been moved correctly.';
          }

    swal(tituloSwal, mensajeSwal, 'success');
  }

  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  validarTitulo() {
    if (this.titulo.split(' ').length <= 20 && this.titulo.split(' ')[0].length > 0) {
      this.tituloValido = true;
    } else {
      this.tituloValido = false;
    }
  }

  validarCategoriaTrabajo() {
    if (this.categoriaTrabajo === '') {
      this.categoriaTrabajoValido = false;
    } else {
      this.categoriaTrabajoValido = true;
    }
  }

  buscarEnLugares2(lugar1: any) {
    let found: boolean = false;
    for (let lugar2 of this.lugaresTrabajo2) {
      if (lugar2.oldId === lugar1.id) {
        found = true;
        return lugar2.id;
      }
    }
    if (!found) {
      lugar1.oldId = lugar1.id;
      lugar1.id = this.lugaresTrabajo2.length + 1;
      this.lugaresTrabajo2.push(lugar1);
      return lugar1.id;
    }
  }

  revisarTrabajo() {
    let editor = this.ckeditor.instance;
    if (this.tituloValido !== 'pristine' && this.tituloValido) {
      if (this.categoriaTrabajo) {
        if (this.autores.length !== 0) {
          if (this.textoTrabajo.length > 0) {
            if ( this.forma.valid ) {

              // Ordenar lugares de trabajos de Autores y marcar lugar como usado
              this.lugaresTrabajo2 = [];
              for (let autor of this.autores) {
                autor.lugaresTrabajo.sort();
                autor.lugaresTrabajo2 = [];
                for (let lugarTrabajoAutor of autor.lugaresTrabajo) {
                  for (let lugarTrabajo of this.lugaresTrabajo) {
                    if ( lugarTrabajo.id === lugarTrabajoAutor ) {
                      lugarTrabajo.usado = true;
                      autor.lugaresTrabajo2.push(this.buscarEnLugares2(JSON.parse(JSON.stringify(lugarTrabajo))));
                    }
                  }
                }
              }

              let arbol: any = this.getArbolCategorias(this.categoriaTrabajo);

              this._categoriaTrabajoService.getArbolCategorias(arbol).subscribe((resp: any) => {
                this.arbolDeCategorias = resp.categoriasTrabajo.reverse();
              });

              this.showRevisarTrabajoModal();

            } else {
              let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Email inválido';
                mensajeSwal = 'El email de contacto no es válido.';
              } else {
                tituloSwal = 'Invalid email';
                mensajeSwal = 'The contact email is not valid.';
              }
              swal(tituloSwal, mensajeSwal, 'error');
            }
          } else {
            let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Texto Inválido';
                mensajeSwal = 'Ingrese el texto del trabajo.';
              } else {
                tituloSwal = 'Invalid text';
                mensajeSwal = 'Enter the text of the job.';
              }
              swal(tituloSwal, mensajeSwal, 'error');
          }
        } else {
          let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Autores inválidos';
                mensajeSwal = 'Seleccione al menos un autor para este trabajo.';
              } else {
                tituloSwal = 'Invalid authors';
                mensajeSwal = 'Select at least one author for this work.';
              }
              swal(tituloSwal, mensajeSwal, 'error');
        }
      } else {
        let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Categoría de Trabajo inválida';
                mensajeSwal = 'La categoría del trabajo no es correcta. Intente con otra categoría.';
              } else {
                tituloSwal = 'Invalid Work Category';
                mensajeSwal = 'The category of work is not correct. Try another category.';
              }
              swal(tituloSwal, mensajeSwal, 'error');
        this.categoriaTrabajoValido = false;
      }
    } else {
      let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Título inválido';
                mensajeSwal = 'El titulo del trabajo no es correcto. Intente con otro título.';
              } else {
                tituloSwal = 'Invalid Title';
                mensajeSwal = 'The title of the work is not correct. Try another title.';
              }
              swal(tituloSwal, mensajeSwal, 'error');
      this.tituloValido = false;
    }
  }

  validarEmailContacto() {
    if (!this.forma.valid) {
      this.emailValido = false;
    } else {
      this.emailValido = true;
    }
  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1) + '.';
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    if (lugaresTrabajo) {
      for (let lugar of lugaresTrabajo) {
        if (superindice === '') {
          superindice = superindice + lugar;
        } else {
          superindice = superindice + ',' + lugar;
        }
      }
    }
    return superindice;
  }

  enviarTrabajo() {
    let trabajo: any = {};
    trabajo.uid = this._userService.user._id;
    trabajo.titulo = this.titulo;
    trabajo.categoriaTrabajoPrincipal = this.categoriaTrabajo;
    trabajo.categoriasTrabajo = this.getArbolCategorias(trabajo.categoriaTrabajoPrincipal);
    for (let autor of this.autores) {
      autor.lugaresTrabajo = autor.lugaresTrabajo2;
    }
    trabajo.autores = this.autores;
    trabajo.lugaresTrabajo = this.lugaresTrabajo2;
    trabajo.textoTrabajo = this.textoTrabajo;
    trabajo.contactoAutor = this.forma.get('email').value;
    trabajo.congreso = this.congreso._id;

    this._trabajosService.crearTrabajo(trabajo).subscribe(resp => {
      this._mailService.mailParaUsuario('enviotrabajo', this.congreso.titulo_es, this._userService.user.name, this._userService.user.apellido, this._userService.user.email, this._userService.user.lang, this.congreso.sociedadOrganizadora, trabajo.titulo, undefined , trabajo.contactoAutor).subscribe(ok => {});
      this._mailService.mailTrabajoRecibidoAdmin( 'trabajorecibido',
                                                this.congreso.titulo_es,
                                                this._userService.user.name,
                                                this._userService.user.apellido,
                                                this.congreso.contactosTrabajos,
                                                this.congreso.sociedadOrganizadora,
                                                this._userService.user.email,
                                                this._userService.user.sociedad,
                                                trabajo.titulo,
                                                this.categoriaTrabajoObj.nombre_es,
                                                trabajo.contactoAutor).subscribe(ok => {});
      this.hideModalMethod2();
      let lang: string = this._translationService.lang;
              let tituloSwal: string;
              let mensajeSwal: string;
              if (lang === 'es') {
                tituloSwal = 'Trabajo Enviado';
                mensajeSwal = 'Nos contactaremos a la brevedad con el resultado de la aprobación.';
              } else {
                tituloSwal = 'Submitted work';
                mensajeSwal = 'We will contact you shortly with the result of the approval.';
              }
              swal(tituloSwal, mensajeSwal, 'success');
      this._userService.user.estadoTrabajo = 'presentado';
      this._userService.saveStorage(this._userService.user._id, this._userService.token, this._userService.user, this._userService.menu);
      this.router.navigate(['/dashboard']);
    });
  }

  getArbolCategorias(categoriaPrincipal: any) {
    let arrayCategoriasTrabajo: any[] = [];
    arrayCategoriasTrabajo.push(categoriaPrincipal);
    let objCategPrincipal: any = this.search(categoriaPrincipal, this.categoriasTrabajo);
    if (objCategPrincipal.parent) {
      arrayCategoriasTrabajo.push(objCategPrincipal.parent);
      let nivel1: any = this.search(objCategPrincipal.parent, this.categoriasTrabajo);
      if (nivel1.parent) {
        arrayCategoriasTrabajo.push(nivel1.parent);
        let nivel2: any = this.search(nivel1.parent, this.categoriasTrabajo);
        if (nivel2.parent) {
          arrayCategoriasTrabajo.push(nivel2.parent);
          let nivel3: any = this.search(nivel2.parent, this.categoriasTrabajo);
          if (nivel3.parent) {
            arrayCategoriasTrabajo.push(nivel3.parent);
            let nivel4: any = this.search(nivel3.parent, this.categoriasTrabajo);
            if (nivel4.parent) {
              arrayCategoriasTrabajo.push(nivel4.parent);
            }
          }
        }
      }
    }
    return arrayCategoriasTrabajo;
  }

  search(nameKey, myArray) {
    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i]._id === nameKey) {
            return myArray[i];
        }
    }
  }

  tieneHijos(categoria: any) {
    if (categoria.childrens.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  capitalize(texto: string) {
    return texto.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trabajos/trabajos.component.ts